import './index.scss';
import { X } from 'react-feather';
import Toast from '../Toast/Toast';
import { Input } from 'reactstrap';
import classNames from 'classnames';
import { toast } from 'react-toastify';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ToastTypeEnum } from '../Toast/toast-type.enum';

interface UploadImageInputProps {
  id?: string;
  className?: string;
  placeholder?: string;
  invalid?: boolean;
  previewHidden?: boolean;
  uploaderHook: (data: any, callback: any) => void; // The hook that you wrote to send the request to the service
  // uploadType: UploadImageTypeEnum;
  fileSize?: number; // in MB, default to 2MB
  acceptedFiles?: string; // default to only images...
  onChange: (value: string) => void;
  value: string;
  hidden?: boolean;
  allowedFormats?: string[];
}

const DEFAULT_FILE_SIZE = 5; // MB
const DEFAULT_ACCEPTED_FILES_TYPES = 'image/*';

const UploadImageInput = React.forwardRef(
  (props: UploadImageInputProps, ref) => {
    const { t } = useTranslation();
    // const stopLoader = useStopLoader();
    // const startLoader = useStartLoader();

    const [imageKey, setImageKey] = useState(1);

    const { uploaderHook, ...inputPropsWithoutUploadType } = props;

    const getFormData = (file: any) => {
      const formData = new FormData();
      formData.append('file', file);
      return formData;
    };

    const getAllowedSize = () => {
      return props.fileSize || DEFAULT_FILE_SIZE;
    };

    const imageSizeIsValid = (selectedFileSize: number) => {
      const allowedSize = getAllowedSize();
      return selectedFileSize <= allowedSize;
    };

    const handleChange = (event: any) => {
      if (!event.target.files) {
        return;
      }

      const allowedFormats = props.allowedFormats || [
        'image/jpeg',
        'image/png',
        'application/pdf',
        'image/gif',
      ];

      if (!allowedFormats.includes(event.target.files[0].type)) {
        return Toast(ToastTypeEnum.ERROR, t('NO_ALLOWED_IMAGE_FORMAT_TEXT'), t);
      }

      const selectedFileSize = event.target.files[0].size / 1024 / 1024; // MB
      if (imageSizeIsValid(selectedFileSize)) {
        const data = getFormData(event.target.files[0]);
        props.uploaderHook(data, (imageUrl: any, error: any) => {
          if (error) {
            return toast.error(
              typeof error === 'string' ? error : 'Something went wrong...'
            );
          }
          if (props.onChange) {
            props.onChange(imageUrl);
          }
        });
      } else {
        toast.error(
          `Image size too big, please upload an image less then ${getAllowedSize()} MB`
        );
      }
      //TODO: return after speaking with Yaniv

      // const selectedFileSize = file.size / 1024 / 1024; // MB
      // if (!imageSizeIsValid(selectedFileSize)) {
      //   return toast.error(`Bad image format, try uploading another one`);
      // }
      //
      // await startLoader();
      //
      // try {
      //   const response = await uploaderService(file, props.uploadType);
      //   props.onChange(response);
      // } catch (error: any) {
      //   console.error(error);
      //   return toast.error(error.message || `Bad request, please try later`);
      // } finally {
      //   await stopLoader();
      // }
    };

    const onRemoveImage = () => {
      if (props.onChange) {
        props.onChange('');
      }
      setImageKey(imageKey + 1);
    };

    return (
      <div className={classNames({ hidden: props.hidden })}>
        <Input
          type="file"
          accept={props.acceptedFiles || DEFAULT_ACCEPTED_FILES_TYPES}
          key={imageKey}
          onChange={handleChange}
          invalid={props.invalid}
          max={'2Mb'}
        />
        {/*// @ts-ignore*/}
        <Input
          type="text"
          {...inputPropsWithoutUploadType}
          className="hidden"
        />
        <div className="file-size-label">
          {t('MAX_FILE_SIZE', { size: '2MB' })}
        </div>
        {!props.previewHidden && props.value && (
          <div className="file-preview" key={props.value}>
            <img src={props.value} alt="" />
            <div className="file-preview-remove" onClick={onRemoveImage}>
              <X />
            </div>
          </div>
        )}
      </div>
    );
  }
);

export default UploadImageInput;
